module.exports = __webpack_public_path__ + "img/collar length.3629b704.png";